import { useSelector } from 'react-redux';
import { MenuTaxonomyState } from '@/reducers/menuTaxonomy';

export default function useMenuTaxonomyList() {
  const menuTaxonomyList = useSelector(
    (state: { menuTaxonomy: MenuTaxonomyState }) => state.menuTaxonomy.menuTaxonomyList
  );

  return menuTaxonomyList;
}
